import { Button, Card } from "@material-ui/core";
import Container from "@saleor/components/Container";
import PageHeader from "@saleor/components/PageHeader";
import SearchBar from "@saleor/components/SearchBar";
import { CoverList_covers_edges_node } from "@saleor/cover/types/CoverList";
import { CoverListUrlSortField } from "@saleor/cover/urls";
import { sectionNames } from "@saleor/intl";
import {
  ListActions,
  PageListProps,
  SearchPageProps,
  SortPage,
  TabPageProps
} from "@saleor/types";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import CoverList from "../CoverList";

export interface CoverListPageProps
  extends PageListProps,
    SearchPageProps,
    ListActions,
    SortPage<CoverListUrlSortField>,
    TabPageProps {
  cover: CoverList_covers_edges_node[];
  toatlCount:number;
}
const CoverListPage: React.FC<CoverListPageProps> = ({
  initialSearch,
  onAdd,
  onSearchChange,
  currentTab,
  onAll,
  onTabChange,
  onTabDelete,
  onTabSave,
  tabs,
  toatlCount,
  ...listProps
}) => {
  const intl = useIntl();
  return (
    <>
      <Container>
        <PageHeader title={intl.formatMessage(sectionNames.cover)+"("+toatlCount+")"}>
          <Button onClick={onAdd} color="primary" variant="contained">
            <FormattedMessage
              defaultMessage="Create Plugin"
              description="button"
            />
          </Button>
        </PageHeader>
        <Card>
          <SearchBar
            allTabLabel={intl.formatMessage({
              defaultMessage: "All Plugs",
              description: "tab name"
            })}
            currentTab={currentTab}
            initialSearch={initialSearch}
            searchPlaceholder={intl.formatMessage({
              defaultMessage: "Search Plugs"
            })}
            tabs={tabs}
            onAll={onAll}
            onSearchChange={onSearchChange}
            onTabChange={onTabChange}
            onTabDelete={onTabDelete}
            onTabSave={onTabSave}
          />
          <CoverList {...listProps} />
        </Card>
      </Container>
    </>
  );
};

export default CoverListPage;
